import React, { forwardRef, useRef, useEffect } from "react";
import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import CircularLoader from "@common/CircularLoader";
import { useSnackbar } from "notistack";

const Snackbar = forwardRef(function Snackbar(
    {
        id,
        title,
        message,
        variant,
        displayLoader = false,
        className,
        style,
        persist,
        lastActiveElement,
        onClose,
        ...otherProps
    },
    ref
) {
    const closeButtonRef = useRef();

    useEffect(() => {
        if (persist && closeButtonRef.current) {
            closeButtonRef.current.focus();
        }
    }, [persist]);

    const titleId = `snack-title-${id}`;
    const messageId = `snack-msg-${id}`;
    const role = variant === 'error' ? 'alert' : 'status';

    return (
        <div
            ref={ref}
            className={className ? className + " ch-snackbar" : "ch-snackbar"}
            style={style}
            role={role}
            aria-labelledby={title ? titleId : undefined}
            aria-describedby={messageId}
            tabIndex={-1}
            {...otherProps}
        >
            <div className="ch-snackbar-content">
                <div className="ch-snackbar-text-wrapper">
                    {title && (
                        <h2 id={titleId} className="ch-snackbar-title">{title}</h2>
                    )}

                    <div
                        id={messageId}
                        className="ch-snackbar-text"
                        dangerouslySetInnerHTML={{ __html: message }}
                    />
                    {displayLoader &&
                        <CircularLoader pageCentered={false} lightStyle={true} />
                    }
                </div>
                <Button
                    ref={closeButtonRef}
                    type="text"
                    size="small"
                    shape="circle"
                    className="ch-snackbar-close-btn"
                    icon={<CloseOutlined style={{ color: "#2196f3" }} />}
                    style={{ backgroundColor: "#fff" }}
                    aria-label="Dismiss notification"
                    onClick={() => onClose(lastActiveElement)}
                />
            </div>
        </div>
    );
});

export default Snackbar;